import { render } from "./ActualityCard.vue?vue&type=template&id=21de860c&scoped=true"
import script from "./ActualityCard.vue?vue&type=script&scoped=true&lang=js"
export * from "./ActualityCard.vue?vue&type=script&scoped=true&lang=js"

import "./ActualityCard.vue?vue&type=style&index=0&id=21de860c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21de860c"]])

export default __exports__